var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiscTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14717_7066)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 2.42505H0.642857C0.287277 2.42505 0 2.71233 0 3.06791V15.925C0 16.2806 0.287277 16.5679 0.642857 16.5679H17.3571C17.7127 16.5679 18 16.2806 18 15.925V3.06791C18 2.71233 17.7127 2.42505 17.3571 2.42505ZM16.5536 15.1215H1.44643V3.87148H16.5536V15.1215Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0177 9.48104C4.0177 9.73678 4.11929 9.98205 4.30013 10.1629C4.48097 10.3437 4.72624 10.4453 4.98199 10.4453C5.23773 10.4453 5.483 10.3437 5.66384 10.1629C5.84468 9.98205 5.94627 9.73678 5.94627 9.48104C5.94627 9.2253 5.84468 8.98003 5.66384 8.79919C5.483 8.61835 5.23773 8.51675 4.98199 8.51675C4.72624 8.51675 4.48097 8.61835 4.30013 8.79919C4.11929 8.98003 4.0177 9.2253 4.0177 9.48104Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31799 10.1629C8.13715 9.98205 8.03556 9.73678 8.03556 9.48104C8.03556 9.2253 8.13715 8.98003 8.31799 8.79919C8.49883 8.61835 8.7441 8.51675 8.99984 8.51675C9.25559 8.51675 9.50086 8.61835 9.6817 8.79919C9.86254 8.98003 9.96413 9.2253 9.96413 9.48104C9.96413 9.73678 9.86254 9.98205 9.6817 10.1629C9.50086 10.3437 9.25559 10.4453 8.99984 10.4453C8.7441 10.4453 8.49883 10.3437 8.31799 10.1629Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3358 10.1629C12.155 9.98205 12.0534 9.73678 12.0534 9.48104C12.0534 9.2253 12.155 8.98003 12.3358 8.79919C12.5167 8.61835 12.762 8.51675 13.0177 8.51675C13.2734 8.51675 13.5187 8.61835 13.6996 8.79919C13.8804 8.98003 13.982 9.2253 13.982 9.48104C13.982 9.73678 13.8804 9.98205 13.6996 10.1629C13.5187 10.3437 13.2734 10.4453 13.0177 10.4453C12.762 10.4453 12.5167 10.3437 12.3358 10.1629Z",
    fill: "black",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14717_7066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscTransactions);
export default __webpack_public_path__ + "static/media/MiscTransactions.296535e0caae7cfea045d7a1f2a805e4.svg";
export { ForwardRef as ReactComponent };